<template lang='pug'>
    v-card(light)
        v-card-title {{title}}
        v-card-text
            v-form(ref='form', @submit.prevent, v-model='formIsValid')
                v-row
                    v-col
                        v-text-field(label='Name', outlined, dense, color='brand', :rules='[rules.required]', v-model='name')
                        v-text-field(label='Contact Phone Number', outlined, dense, color='brand', type='tel', :rules='[rules.required, rules.phone]', v-model='phoneNumber')
                        v-text-field(label='Contact Email', outlined, dense, color='brand', :rules='[rules.required, rules.email]', v-model='email')
                        v-text-field(label='Site Name', disabled, outlined, dense, color='brand', v-model='customerName')
                        template(v-if='serviceName === "SCADAsure"', outlined, dense)
                            v-text-field(label='Distribution Group Email', outlined, dense, color='brand', :rules='[rules.required, rules.email]', v-model='distributionEmail')
                                template(v-slot:append-outer)
                                    v-tooltip(top)
                                        template(v-slot:activator="{ on, attrs }")
                                            v-icon(v-on='on') info
                                        span This is the email SCADAsure alerts will be sent to.
                v-row
                    v-col
                        p I understand and agree that this is a recurring monthly service billed quarterly at the agreed-upon rates, and that charges will continue until the service is cancelled in accordance with the company's cancellation policy.
                        v-checkbox(label='I Agree', color='brand', v-model='userHasAgreedToTerms')
        v-card-actions
            v-spacer
            v-btn(text) Cancel
            v-btn.white--text(small, color='brand', :disabled='!userHasAgreedToTerms || !formIsValid', type='submit', @click='requestFeatureAccess') Submit
        v-dialog(v-model='showSubmittedModal', max-width='500', persistent)
            v-card(light)
                v-card-title Request submitted
                v-card-text
                    p Your request has been submitted. A Dorsett representative will reach out to you soon to schedule a time to set up the service.
                v-card-actions
                    v-spacer
                    v-btn.white--text(@click='acknowledgeRequestSubmitted', small, color='brand') Ok
        v-snackbar(v-model='showAlert', dark, :timeout='3000') {{ message }}
</template>
<script>

const SERVICES = ['SCADAsure', 'InfoBak'];

import parsePhoneNumber from 'libphonenumber-js';
import isEmail from 'isemail';

export default {
    props: {
        title: {
            type: String,
            default () {
                return 'Sign up now';
            }
        },
        serviceName: {
            type: String,
            default () {
                return SERVICES[0];
            }
        }
    },
    data () {
        return {
            showForm: false,
            userHasAgreedToTerms: false,
            name: '',
            email: '',
            phoneNumber: '',
            distributionEmail: '',
            showSubmittedModal: false,
            formIsValid: false,
            message: '',
            rules: {
                required: value => !!value || 'Required',
                phone: value => {
                    let result = false;
                    if(value?.length === 0) {
                        result = true;
                    } else {
                        const phone = parsePhoneNumber(value, 'US');
                        if(phone) {
                            result = phone.isValid() || 'Invalid phone number';
                        } else {
                            result = 'Invalid phone number';
                        }
                        return result;
                    }
                    return result;
                },
                email: value => {
                    let result = false;
                    if(value?.length === 0) {
                        result = true;
                    } else {
                        result = isEmail.validate(value) || 'Invalid email address';
                    }
                    return result;
                }
            }
        };
    },
    methods: {
        async requestFeatureAccess () {
            // if request is already submitted - show warning or info abnout it.
            try {
                const results = await this.post(
                    'requestFeatureAccess',
                    {
                        type: this.serviceName,
                        customerId: this.$store.state.customerId,
                        name: this.name,
                        email: this.email,
                        phoneNumber: this.phoneNumber,
                        distributionEmail: this.distributionEmail,
                        username: this.$store.state.fullUser.username
                    }
                );
                if (results.success) {
                    this.showSubmittedModal = true;
                } else {
                    this.message = 'Something went wrong. Please try again. If the problem persists, contact Dorsett Customer Support';
                }
            } catch (err) {
                this.message = 'Something went wrong. Please try again. If the problem persists, contact Dorsett Customer Support';
                console.error(err);
            }
        },
        acknowledgeRequestSubmitted () {
            this.showSubmittedModal = false;
            this.$emit('done');
        }
    },
    computed: {
        customerId () {
            return this.$store.state.customerId;
        },
        customer () {
            return this.$store.state.customerData;
        },
        customerName () {
            return this.$store.state.customerData?.name;
        },
        showAlert: {
            get () {
                return this.message !== '';
            },
            set (val) {
                if (val === false) {
                    this.message = '';
                }
            },
        },
    }
};
</script>